const translations: Record<string, JSX.Element> = {
  pt: (
    <>
      <p>Esta é uma área interativa.</p>
      <p>Escolha um quadro e faça a sua própria obra.</p>
    </>
  ),
  en: (
    <>
      <p>This is an interactive area.</p>
      <p>Pick a frame and do your own painting.</p>
    </>
  )
}

const Interactive: React.FC = () => {
  return (
    <div>
      {
        translations[window.location.pathname.substring(1)] ||
        translations['pt']
      }
    </div>
  );
}

export default Interactive;
